import { useTranslation } from 'react-i18next';
import { Progress } from '@/components/ui/progress';

interface StepProgressProps {
  currentStep: number;
  totalSteps: number;
  label?: string;
  className?: string;
}

export function StepProgress({
  currentStep,
  totalSteps,
  label,
  className,
}: StepProgressProps) {
  const { t } = useTranslation('staff');
  const percent = totalSteps > 0 ? (currentStep / totalSteps) * 100 : 0;
  return (
    <div className={`space-y-2 py-2${className ? ` ${className}` : ''}`}>
      <div className="flex items-baseline justify-between">
        <span className="text-mono-eyebrow uppercase text-soft">
          {t('availability.wizard.stepOf', { current: currentStep, total: totalSteps })}
        </span>
        {label ? <span className="text-label text-ink">{label}</span> : null}
      </div>
      <Progress value={percent} />
    </div>
  );
}
